import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IContentTileExpectedObj } from 'ui-ng-content-tile';
import { IDatasource, ORM } from 'utility-ts-orm';
import { Survey } from '../builders/survey_builder';

export class SurveyPriorityFeedQuery implements IQuery {
  private _result: IContentTileExpectedObj[];
  private _count: number;

  constructor(private ngSurveyDatastore: IDatasource<Survey>) {
    ORM.registerQuery(this, this.ngSurveyDatastore);
  }

  run(): this {
    let _newAndInProgressSurveys = _4.filter(this.ngSurveyDatastore.values(), (survey: Survey) => {
      return survey.combined_status === 'NEW' || survey.combined_status === 'IN_PROGRESS';
    });
    this._count = _newAndInProgressSurveys.length;
    this._result = this._generatePriorityFeedItemForSurveys(_newAndInProgressSurveys);
    return this;
  }

  get result() {
    return this._result;
  }

  get count() {
    return this._count;
  }

  private _generatePriorityFeedItemForSurveys(surveys: Survey[]) {
    const baseConfiguration = {
      icon: { type: 'bubble_question', theme: 'blue' },
      isOverdue: false,
      isActive: this._count > 0
    };

    return _4.map(surveys, (survey: Survey) => {
      return {
        ...baseConfiguration,
        text: {
          title: survey.external_title,
          subTitle: 'Tap to start the survey'
        },
        action: {
          state: 'my.survey-intro',
          params: {
            surveyID: survey.id
          }
        }
      };
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/queries/survey_priority_feed_query.ts